"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var $carousel = $('.tabs-wrapper');
    var $readMore = $('.hiw-case-buttons__read-more');
    var $readLess = $('.hiw-case-buttons__read-less');
    var $carouselLoop = $('.tab').length === 3;
    // const showText = function() {
    //     $(this).parents('.hiw-case-buttons').siblings('.tab__title-tab').toggleClass('d-none');
    //     $(this).parents('.hiw-case-buttons').siblings('.tab__description').fadeToggle();
    //     const toggleClass = $(this).parents('.hiw-case-buttons').siblings('.tab__title-tab').hasClass('d-none') ?
    //     '.hiw-case-buttons__read-less' : '.hiw-case-buttons__read-more';
    //     $(this).fadeToggle();
    //
    //     $(this).siblings(toggleClass).delay(500).fadeToggle(100);
    // }
    // if(typeof $readMore !== 'undefined' && typeof $readLess !== 'undefined') {
    //     $readMore.on('click', showText);
    //     $readLess.on('click', showText);
    // }
    var owlCarousel = function () {
        $carousel.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: true,
            autoplay: false,
            dots: true,
            loop: $carouselLoop,
            navText: [
                '<img src="/app/themes/tedee/assets/images/arrow-gray-left.svg" alt="prev arrow" />',
                '<img src="/app/themes/tedee/assets/images/arrow-gray-right.svg" alt="next arrow" />'
            ],
            responsive: {
                768: {
                    items: 2
                },
                1240: {
                    items: 3
                }
            }
        });
    };
    owlCarousel();
};
exports.init = init;
